<div>
    <h2 class="mat-subheading-2">Captura de biométricos</h2>
</div>
<div class="terms-and-conditions container mx-auto px-7 pb-3 block">
    <div *ngIf="!validData" class="error-component">
        <span>
            No hay información suficiente para iniciar los biométricos
        </span>
    </div>

    <div class="content-button" *ngIf="validData">
        <button mat-raised-button type="button" (click)="startBiometrics()"
            color="accent">
            <span *ngIf="!loading">Iniciar biométricos</span>
            <mat-spinner [diameter]="30" class="loading-spinner" *ngIf="loading"></mat-spinner>
        </button>
    </div>
    <div class="instruction" *ngIf="loading">
        <span>
            Capture los biométricos, y regrese para seguir con el proceso, no cierre el navegador o la sesión.
        </span>
    </div>
    <div *ngIf="errorBiometrics" class="error-component">
        <span>
            Ocurrió un error durante la lectura de los biométricos, De clic en  Iniciar biométricos para intentar nuevamente.
        </span>
    </div>
</div>
